import Types from '../types';

export default (reducerState = [], action) => {
  switch (action.type) {
    case Types.SET_COURSE_CLASSWORK:
      return action.payload;
    default:
      return reducerState;
  }
};
